import React, { useState } from "react";
import "./Hero.css";

function Hero() {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <section className="container-fluid" id="supportHero">
      {/* Header with Support Portal and Track Tickets */}
      <div className="p-3 p-md-5 mt-3" id="supportWrapper">
        <h5>Support Portal</h5>
        <a href="#" className="track-link">Track tickets</a>
      </div>
      
      <div className="row p-md-5 m-md-3 mt-3">
        {/* Search Column */}
        <div className="col-lg-6 col-sm-12 p-md-5 mt-2 mb-2">
          <h1 className="fs-4">Search for an answer or browse help topics to create a ticket</h1>
          
          {/* Search Input with Icon */}
          <div className="search-container mt-3 mb-3">
            <input 
              type="text" 
              placeholder="Eg: how do i activate F&O, why is my order getting rejected ..." 
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="search-button">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </button>
          </div>
          
          {/* Quick Links */}
          <div className="quick-links">
            <a href="#" className="mx-1">Track account opening</a>
            <a href="#" className="mx-1">Track segment activation</a>
            <a href="#" className="mx-1">Intraday margins</a>
            <a href="#" className="mx-1">Kite user manual</a>
          </div>
        </div>
        
        {/* Featured Column */}
        <div className="col-lg-6 col-sm-12 p-md-5">
          <h1 className="fs-4">Featured</h1>
          <div className="featured-list">
            <div className="featured-item">
              <span className="featured-number">1</span>
              <a href="#">Current Buybacks - August 2024</a>
            </div>
            <div className="featured-item">
              <span className="featured-number">2</span>
              <a href="#">Offer for sale (OFS) - August 2024</a>
            </div>
          </div>
          
          {/* Help Card */}
          <div className="help-card mt-4">
            <h3>Need assistance?</h3>
            <p>Our support team is available to help with any questions</p>
            <a href="#" className="contact-link">Contact Support</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;